import { Sidebar } from '../../../shared/components/MenuSidebar/Sidebar';
import { Navbar } from '../../../shared/components/Navbar';
import { Logo } from '../../../shared/Icons/Logo';

export function Dashboard() {

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex mx-auto justify-center items-center h-[100vh]">
        <Logo height='8rem'/>
      </div>
    </div>
  );
}